export default __webpack_public_path__ + "static/media/deliverer.2ff16bc8.jpg";